export class PageInfo {
    PageSize: number = 25;
    Page: number = 1;
}
